import axios from 'axios'
import { useAuthStore } from '@/stores/auth'

// Récupérer la base URL depuis les variables d'environnement
// Si VITE_API_URL n'est pas définie, utiliser /api comme préfixe par défaut
const apiUrl = import.meta.env.VITE_API_URL || '/api'

// Détecter l'environnement pour le logging
const isDev = import.meta.env.VITE_DEV_MODE === 'true'

// Afficher des informations de débogage en mode développement
if (isDev) {
  // Configuration du mode développement
}

// Créer une instance axios avec la configuration de base
const axiosInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Ajouter un intercepteur pour ajouter le token d'authentification
axiosInstance.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore()
    const token = authStore.accessToken
    
    if (isDev) {
      // Vérification du token pour l'authentification
    }
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      if (isDev) {
        // Token ajouté aux headers
      }
    } else if (isDev) {
      // Log uniquement en mode développement
      // Aucun token disponible pour cette requête - continuer sans authentification
    }
    
    return config
  },
  (error) => {
    if (isDev) {
      // Gestion silencieuse des erreurs dans l'intercepteur de requête
    }
    return Promise.reject(error)
  }
)

export default axiosInstance

